export { default } from './DemographicItem';
